export enum EscalationEmailResults {
  Canceled = 'canceled',
  SaveAsDraft = 'saveAsDraft',
}
